<template>
  <div class="deletion-page">
    <main class="container" role="main" aria-labelledby="pageTitle">
      <h1 id="pageTitle">Điều khoản & Quy trình Xóa Tài khoản — HKOIL KCLUB</h1>

      <p class="intro"><bold>Thông báo quan trọng:</bold> Đây là quy trình chính thức xử lý yêu cầu vô hiệu hóa và xóa tài khoản người dùng trên ứng dụng <span>HKOIL KCLUB</span> được phát triển bởi <a :href="'mailto:' + deletionEmail">{{ deletionEmail }}</a>. Vui lòng đọc kỹ trước khi gửi yêu cầu. Nội dung đảm bảo tuân thủ chính sách Google Play về xóa dữ liệu người dùng và quy định pháp luật Việt Nam.</p>

      <section>
        <h2>1. Các phương thức yêu cầu xóa tài khoản</h2>
        <p>Bạn có thể yêu cầu xóa tài khoản bằng một trong các cách sau:</p>
        <ul>
          <li>Trong ứng dụng: Mục Tài Khoản → Cài đặt nâng cao → Yêu cầu xóa tài khoản (ưu tiên, nếu có).</li>
          <li>Email chính thức: gửi yêu cầu tới <a :href="'mailto:' + deletionEmail">{{ deletionEmail }}</a> (tiêu đề: Yêu cầu xóa tài khoản HKOIL KCLUB).</li>
          <li>Tới trực tiếp: Đến cửa hàng HKOIL gần nhất để trình diện và yêu cầu xóa tại quầy dịch vụ.</li>
        </ul>
        <p>Mọi yêu cầu phải xuất phát từ chủ tài khoản (hoặc người đại diện hợp pháp) kèm thông tin xác thực cần thiết để bảo vệ quyền lợi.</p>
      </section>

      <section>
        <h2>2. Xác minh yêu cầu (bắt buộc)</h2>
        <p>Để tránh xóa trái phép, HKOIL sẽ tiến hành xác minh trước khi tiếp tục:</p>
        <ol>
          <li>Kiểm tra phiên đăng nhập (in-app) hoặc yêu cầu xác thực qua email/tài liệu có giá trị pháp lý.</li>
          <li>Trong trường hợp yêu cầu qua email, HKOIL sẽ gửi email xác nhận yêu cầu tới địa chỉ email đăng ký trước khi tiến hành vô hiệu hóa.</li>
          <li>Nếu yêu cầu nộp giấy tờ (tại cửa hàng) để xác minh danh tính, HKOIL sẽ hướng dẫn cụ thể và ghi lại biên nhận.</li>
        </ol>
      </section>

      <section>
        <h2>3. Quy trình xử lý & thời hạn</h2>
        <p>Quy trình tiêu chuẩn:</p>
        <ul>
          <li>Bước 1 — Xác nhận nhận yêu cầu: HKOIL sẽ xác nhận đã nhận yêu cầu trong vòng <strong>03 (ba) ngày làm việc</strong>.</li>
          <li>Bước 2 — Xác minh: Hoàn tất quy trình xác minh trong vòng <strong>07 (bảy) ngày làm việc</strong> kể từ khi xác nhận nhận yêu cầu.</li>
          <li>Bước 3 — Vô hiệu hóa tạm thời: Sau xác minh, tài khoản sẽ <strong>được vô hiệu hóa ngay</strong> (không thể đăng nhập).</li>
          <li>Bước 4 — Xóa vĩnh viễn: Nếu trong vòng <strong>30 (ba mươi) ngày</strong> kể từ ngày vô hiệu hóa không có yêu cầu khôi phục hợp lệ, tài khoản sẽ bị <strong>xóa vĩnh viễn</strong> và không thể khôi phục.</li>
        </ul>
        <p>HKOIL sẽ thông báo bằng email khi tài khoản đã bị vô hiệu hóa và khi việc xóa vĩnh viễn hoàn tất.</p>
      </section>

      <section>
        <h2>4. Dữ liệu sẽ bị xóa và dữ liệu bắt buộc phải lưu</h2>
        <p>Khi xóa vĩnh viễn, HKOIL sẽ xóa thông tin cá nhân liên quan đến tài khoản (ví dụ: tên, email liên hệ, hồ sơ người dùng, điểm thưởng, lịch sử giao dịch hiển thị cho người dùng), trừ những trường hợp sau vì lý do pháp lý hoặc vận hành:</p>
        <ul>
          <li>Chứng từ kế toán, hóa đơn: có thể được lưu trữ theo quy định kế toán (lưu ở dạng tách danh tính hoặc mã hóa để hạn chế truy xuất thông tin cá nhân).</li>
          <li>Thông tin cần giữ lại phục vụ điều tra gian lận, an ninh hoặc khi được yêu cầu bởi cơ quan nhà nước có thẩm quyền — trong phạm vi tối thiểu và có cơ sở pháp lý.</li>
        </ul>
        <p>Mọi dữ liệu giữ lại sẽ được hạn chế, lưu trữ an toàn và chỉ dùng cho mục đích pháp lý/thức thi hành quy định bắt buộc. HKOIL cam kết tối ưu hóa để <strong>không giữ dữ liệu cá nhân hơn mức cần thiết</strong>.</p>
      </section>

      <section>
        <h2>5. Khôi phục tài khoản</h2>
        <p>Trong thời hạn 30 ngày kể từ ngày vô hiệu hóa, người dùng có thể yêu cầu khôi phục bằng cách:</p>
        <ul>
          <li>Đăng nhập (nếu ứng dụng cho phép) và làm theo hướng dẫn khôi phục, hoặc</li>
          <li>Gửi yêu cầu khôi phục tới <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a> kèm thông tin xác thực. HKOIL xem xét và phản hồi trong vòng 7 ngày làm việc.</li>
        </ul>
        <p>Sau 30 ngày, khi tài khoản đã bị xóa vĩnh viễn thì <strong>không thể khôi phục</strong>.</p>
      </section>

      <section>
        <h2>6. Trách nhiệm và quyền của HKOIL</h2>
        <p>HKOIL có quyền từ chối hoặc tạm hoãn tiến trình xóa nếu:</p>
        <ul>
          <li>Có tranh chấp, khiếu nại hoặc nghĩa vụ pháp lý liên quan đến tài khoản.</li>
          <li>Phát hiện dấu hiệu gian lận, lạm dụng hoặc yêu cầu không đủ thông tin xác thực.</li>
        </ul>
        <p>HKOIL sẽ cung cấp lý do từ chối và hướng dẫn bước tiếp theo cho người dùng trong thông báo xác nhận.</p>
      </section>

      <section class="warning">
        <h2>7. Cảnh báo</h2>
        <p>HKOIL không chịu trách nhiệm cho bất kỳ dữ liệu, điểm thưởng, khuyến mãi hoặc quyền lợi nào bị mất do việc xóa tài khoản. Quyết định xóa là cuối cùng sau thời hạn 30 ngày.</p>
      </section>

      <section class="contact">
        <h2>8. Cách liên hệ chính thức</h2>
        <p>Để yêu cầu xóa tài khoản hoặc liên hệ về vấn đề liên quan, sử dụng:</p>
        <ul>
          <li>Email hỗ trợ dữ liệu (ưu tiên): <a :href="'mailto:' + deletionEmail">{{ deletionEmail }}</a></li>
          <li>Email chung hỗ trợ khách hàng: <a href="mailto:info@hkoil.org">info@hkoil.org</a></li>
          <li>Đến trực tiếp cửa hàng HKOIL gần nhất để xác minh và nhận hỗ trợ trực tiếp.</li>
        </ul>
        <p>Yêu cầu gửi tới email khác sẽ không được coi là chính thức cho đến khi HKOIL xác nhận nhận yêu cầu.</p>
      </section>

      <section>
        <h2>9. Hồ sơ & Khiếu nại</h2>
        <p>Nếu bạn có khiếu nại về cách HKOIL xử lý yêu cầu xóa tài khoản, bạn có thể phản ánh tới email trên; nếu cần giải quyết theo pháp luật, các bên sẽ áp dụng pháp luật Việt Nam và thỏa thuận giải quyết tranh chấp.</p>
      </section>

      <footer class="meta">
        <p>Phiên bản chính sách này có hiệu lực kể từ ngày công bố và được HKOIL cập nhật khi cần để tuân thủ pháp luật và chính sách Google Play.</p>
      </footer>
    </main>
  </div>
</template>

<script>
export default {
  name: 'AccountDeletionPolicy',
  data() {
    return {
      deletionEmail: 'hkoilxd@gmail.com', // chính thức cho yêu cầu xóa (theo yêu cầu của bạn)
      supportEmail: 'info@hkoil.org'
    };
  }
};
</script>

<style scoped>
.deletion-page {
  padding: 28px 12px;
  display:flex;
  justify-content:center;
  background: #f7f7f8;
}
.container {
  width:100%;
  max-width:920px;
  background:#fff;
  border-radius:10px;
  padding:24px;
  box-shadow:0 6px 24px rgba(0,0,0,0.06);
  color:#222;
  line-height:1.65;
}
h1 { font-size:20px; margin-bottom:8px; color:#b02a37; font-weight:700; }
h2 { font-size:16px; margin-top:16px; color:#9b2c2c; }
.intro { margin-bottom:12px; color:#333; font-weight:600; }
.warning { background:#fff4f4; border-left:4px solid #e11d48; padding:12px; border-radius:6px; margin-top:12px; }
.contact a { color:#b02a37; text-decoration:none; font-weight:600; }
a {
  color: #b02a37;
  text-decoration: none;
}
p span {
  color: #b02a37;
}
.contact a:hover { text-decoration:underline; }
.meta { margin-top:18px; color:#666; font-size:13px; }
ul, ol { margin-left:16px; }
@media (max-width:600px){
  .container{ padding:16px }
  h1{font-size:18px}
  h2{font-size:15px}
}
</style>
